import { RateCheckerState } from '@/views/rate-checker-configuration/rate-checker/rate-checker.types';

const state: RateCheckerState = {
  loading: false,
  dataSource: [],
  brandDataSource: '',
  sources: [],
  orderListOfSources: [],
};

export default state;
